export default __webpack_public_path__ + "static/media/question-bank.a9d72c07.jpg";